import { Box, Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";


const Invite = () => {
  const {activationToken} = useParams();

  return (
    
    <Typography variant="body2">Invites to create the tenant</Typography>

  );
};

export default Invite;
